import { render, staticRenderFns } from "./AppLoaderScreen.vue?vue&type=template&id=1ddd463a&scoped=true&"
import script from "./AppLoaderScreen.vue?vue&type=script&lang=js&"
export * from "./AppLoaderScreen.vue?vue&type=script&lang=js&"
import style0 from "./AppLoaderScreen.vue?vue&type=style&index=0&id=1ddd463a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd463a",
  null
  
)

export default component.exports